import { render, staticRenderFns } from "./radio-sf36score.vue?vue&type=template&id=ac6fca8e&scoped=true&"
import script from "./radio-sf36score.vue?vue&type=script&lang=ts&"
export * from "./radio-sf36score.vue?vue&type=script&lang=ts&"
import style0 from "./radio-sf36score.vue?vue&type=style&index=0&id=ac6fca8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6fca8e",
  null
  
)

export default component.exports